import React, { useEffect } from 'react';
import Cookies from "js-cookie";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { loginApi } from '../http/http';

const Auth = ({ children }) => {

    const navigate = useNavigate();

    const checkSubscription = async (msisdn) => {
        try {
            const response = await loginApi(msisdn);
            console.log(response?.data, 'response===');

            if (response?.data?.result?.statusCode == 200) {
                console.log("Success====");
            }
            else if (response?.data?.result?.statusCode == 400) {
                console.log("Low Balance===");
                toast.warn(response?.data?.result?.message);
                Cookies.remove("msisdn");
                navigate("/");
            }
            else if (response?.data?.result?.statusCode == 403) {
                console.log("You are not subscribed!");
                toast.error(response?.data?.result?.message);
                Cookies.remove("msisdn");
                navigate("/");
            }
            else {
                Cookies.remove("msisdn");
                navigate("/");
            }
        } catch (error) {
            console.log(error, "error");
        }
    }

    useEffect(() => {
        if (Cookies.get("msisdn")) {
            checkSubscription(Cookies.get("msisdn"));
        }
        else {
            navigate("/");
        }
    }, []);
    return (
        <>
            {children}
        </>
    )
}

export default Auth